module.exports = __webpack_public_path__ + "static/StyreneA-Regular-a957bc64a59ebfb89ab6d94023717116.svg";